// src/pages/dashboard.js
import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';
import { PriceProvider } from '../context/PriceContext';
import Logo from '../assets/logo.png';

// SpeedDial (Hızlı Menü) Bileşenleri
import {
  SpeedDial,
  SpeedDialAction,
  SpeedDialIcon,
  Avatar,
  IconButton,
  Tooltip,
  Drawer,
  List,
  ListSubheader,
  ListItemButton,
  ListItemText,
  Divider,
  Stack
} from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate'; 
import EventIcon from '@mui/icons-material/Event'; 
import NotificationsIcon from '@mui/icons-material/Notifications'; 
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'; 
import PointOfSaleIcon from '@mui/icons-material/PointOfSale'; // YENİ: POS İkonu
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import DescriptionIcon from '@mui/icons-material/Description';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNew';

// Kendi Bileşenlerimiz
import BildirimKutusu from "../components/BildirimKutusu"; 
import AjandaKutusu from "../components/AjandaKutusu"; 
import HesapMakinesiKutusu from "../components/HesapMakinesiKutusu";
import PosCihaziKutusu from "../components/PosCihaziKutusu"; // YENİ: POS Bileşeni Import Edildi
import CampaignModal from '../components/campaign/CampaignModal';
import LiveBankModal from '../components/banking/LiveBankModal';
import InvoiceModal from '../components/invoices/InvoiceModal';

// Sayfa Bileşenleri
import YeniIslem from './yeniislem';
import HizliIslem from './hizliislem';
import TumIslemler from './tumislemler';
import MusteriEkle from './musteriekle';
import MusteriListesi from './musterilistesi';
import TeslimatListesi from './TeslimatListesi';
import MusteriBakiyeler from './MusteriBakiyeler'; 
import FirmaEkle from './firmaekle';
import FirmaListesi from './firmalistesi';
import GunsonuKasa from './gunsonukasa';
import MevcutKasa from './mevcutkasa';
import OncekiKasa from './oncekikasa';
import GecmisKasaAra from './gecmiskasaara';
import GunlukRaporlar from './gunlukraporlar';
import HaftalikRaporlar from './haftalikraporlar';
import AylikRaporlar from './aylikraporlar';
import RaporOlustur from './raporolustur';
import KullaniciYonetimi from './kullaniciyonetimi';
import SubeYonetimi from './subeyonetimi';
import PersonelYonetimi from './personelyonetimi'; 
import FirmaBakiyeler from './firmabakiyeler';
import OzelRaporlar from './ozelraporlar';
import SubeBilgileri from './subebilgileri';
import SubeDegistir from './subedegistir';
import GuncelFiyatEkrani from './guncelfiyatekrani';
import ReferansFiyatEkrani from './referansfiyatekrani';
import Urunekle from './urunekle';
import UrunListesi from './urunlistesi';
import Banka from './banka';
import MagazaDurumu from './magazadurumu';
import BildirimYonetimi from './bildirim';
import WhatsappAyarlari from './whatsappAyarlari';
import FinansPage from './finans/FinansPage';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Alert, Box } from '@mui/material';

const ADMIN_AUTH_ERROR_MESSAGES = {
  'auth/invalid-credential': 'E-posta veya şifre hatalı.',
  'auth/invalid-email': 'Geçersiz e-posta adresi.',
  'auth/user-not-found': 'E-posta veya şifre hatalı.',
  'auth/wrong-password': 'E-posta veya şifre hatalı.',
  'auth/too-many-requests': 'Çok fazla deneme yapıldı. Lütfen biraz sonra tekrar deneyin.',
  'auth/user-disabled': 'Bu hesap devre dışı bırakılmış.',
  'auth/network-request-failed': 'Ağ bağlantısı hatası. Lütfen tekrar deneyin.'
};

const getAdminAuthErrorMessage = (err) =>
  ADMIN_AUTH_ERROR_MESSAGES[err?.code] || 'Giriş yapılamadı. Lütfen tekrar deneyin.';

function Dashboard({ selectedModule: moduleProp, selectedCategory: categoryProp }) {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const sube = queryParams.get('sube') || 'Bilinmeyen Şube';
  
  // State'ler
  const [activePersonel, setActivePersonel] = useState(null); 
  const [branchAuthIsAdmin, setBranchAuthIsAdmin] = useState(false); 
  const [selectedModule, setSelectedModule] = useState(moduleProp || null);
  const [selectedCategory, setSelectedCategory] = useState(categoryProp || null);
  const [currentTime, setCurrentTime] = useState(new Date());
  
  const [showExitModal, setShowExitModal] = useState(false);
  const [showAdminDialog, setShowAdminDialog] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [adminError, setAdminError] = useState('');
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);

  // --- HIZLI ARAÇLAR KONTROLÜ (SpeedDial) ---
  const [openBildirim, setOpenBildirim] = useState(false);
  const [openAjanda, setOpenAjanda] = useState(false);
  const [openHesap, setOpenHesap] = useState(false);
  const [openPos, setOpenPos] = useState(false); // YENİ: POS State
  const [openCampaignModal, setOpenCampaignModal] = useState(false);
  const [openLiveBankModal, setOpenLiveBankModal] = useState(false);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [openMobileDrawer, setOpenMobileDrawer] = useState(false);
  // Cekmece iki seviyeli: null -> modul listesi, dolu -> o modulun kategorileri.
  // Onceden kategoriler modul listesinin ALTINA ekleniyordu ve ekranin disinda
  // kaliyordu; artik listenin yerini aliyor, ustteki geri dugmesiyle donuluyor.
  const [drawerModule, setDrawerModule] = useState(null);

  useEffect(() => {
    if (moduleProp) setSelectedModule(moduleProp);
    if (categoryProp) setSelectedCategory(categoryProp);
  }, [moduleProp, categoryProp]);

  // Otomatik eşleştirme Faturalar modalı içinde çalışır (dashboard açılışını yormamak için burada yok).

  const toSafeSessionPersonel = (personel) => ({
    id: personel?.id,
    isim: personel?.isim || '',
    soyisim: personel?.soyisim || '',
    rol: personel?.rol || 'personel',
    aktif: personel?.aktif !== false,
    yetkiler: personel?.yetkiler || { subeler: [], moduller: [], ozelIzinler: {} }
  });

  // 1. GÜVENLİK KONTROLÜ (Sayfa Yüklenince)
  useEffect(() => {
    let mounted = true;
    const hydrateSession = async () => {
      // Şube izolasyonu: hangi şube hesabı ile giriş yapıldıysa URL’deki `sube` onu göstermeli.
      // Aksi halde ekran açılır ama veriler rules tarafından bloklanır.
      try {
        const uid = auth.currentUser?.uid;
        if (!uid) {
          navigate('/giris', { replace: true });
          return;
        }
        const branchUserSnap = await getDoc(doc(db, 'kullanicilar', uid));
        if (!branchUserSnap.exists()) {
          navigate('/giris', { replace: true });
          return;
        }
        const role = branchUserSnap.data()?.rol;
        const branchKey = branchUserSnap.data()?.subeKey;
        const isAdminUser = role === 'admin';
        setBranchAuthIsAdmin(isAdminUser);
        if (!isAdminUser && branchKey && branchKey !== sube) {
          navigate(`/dashboard?sube=${branchKey}`, { replace: true });
          return;
        }
      } catch (e) {
        navigate('/giris', { replace: true });
        return;
      }

      const savedPersonel = localStorage.getItem('aktifPersonel');
      if (!savedPersonel) {
        navigate('/subesecimi');
        return;
      }
      let parsed;
      try {
        parsed = JSON.parse(savedPersonel);
      } catch (e) {
        localStorage.removeItem('aktifPersonel');
        navigate('/subesecimi');
        return;
      }
      const personelId = parsed?.id;
      if (!personelId) {
        localStorage.removeItem('aktifPersonel');
        navigate('/subesecimi');
        return;
      }
      try {
        const snap = await getDoc(doc(db, 'personeller', personelId));
        if (!snap.exists()) {
          localStorage.removeItem('aktifPersonel');
          navigate('/subesecimi');
          return;
        }
        const p = toSafeSessionPersonel({ ...snap.data(), id: snap.id });
        const hasBranch = p.yetkiler?.subeler?.includes(sube);
        const isAdmin = p.rol === 'admin';
        if (!p.aktif || (!hasBranch && !isAdmin)) {
          alert("Bu şubede işlem yapma yetkiniz yok!");
          localStorage.removeItem('aktifPersonel');
          navigate('/subesecimi');
          return;
        }
        if (!mounted) return;
        setActivePersonel(p);
        setIsAdminAuthenticated(isAdmin);
      } catch (err) {
        console.error('Personel doğrulama hatası:', err);
        localStorage.removeItem('aktifPersonel');
        navigate('/subesecimi');
      }
    };
    hydrateSession();

    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => {
      mounted = false;
      clearInterval(timer);
    };
  }, [sube, navigate]);

  const checkAdminRole = async (uid) => {
    try {
      const userDoc = doc(db, 'kullanicilar', uid);
      const userSnap = await getDoc(userDoc);
      return userSnap.exists() && userSnap.data().rol === 'admin';
    } catch (err) {
      console.error('Rol kontrol hatası:', err);
      setAdminError('Yetki kontrolü yapılamadı. Lütfen tekrar deneyin.');
      return false;
    }
  };

  const handleAdminLogin = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const isAdmin = await checkAdminRole(userCredential.user.uid);
      if (isAdmin) {
        setIsAdminAuthenticated(true);
        setBranchAuthIsAdmin(true);
        setShowAdminDialog(false);
        setAdminError('');
        setSelectedModule('YÖNETİCİ');
      } else {
        setAdminError('Yönetici yetkiniz yok.');
        await auth.signOut();
      }
    } catch (err) {
      console.error('Giriş hatası:', err);
      setAdminError(getAdminAuthErrorMessage(err));
    }
  };

  const handleAdminDialogClose = () => {
    setShowAdminDialog(false);
    setEmail('');
    setPassword('');
    setAdminError('');
    setSelectedModule(null);
  };

  // --- MENÜ YETKİLENDİRMESİ VE FİLTRELEME ---
  const allModules = [
    'YENİ İŞLEM', 'İŞLEMLER', 'MÜŞTERİLER', 'FİRMALAR', 'KASA',
    'RAPORLAR', 'YÖNETİCİ', 'ŞUBE', 'SARRAF', 'ÜRÜNLER', 'ÇIKIŞ'
  ];

  const displayedModules = allModules.filter(module => {
    if (module === 'ÇIKIŞ') return true;
    if (activePersonel?.rol === 'admin') return true;
    return activePersonel?.yetkiler?.moduller?.includes(module);
  });

  // Cekmece acilirken: acik bir modul varsa dogrudan onun kategorilerini goster,
  // yoksa modul listesinden basla. Kapaninca seviye sifirlanmaz ki kullanici
  // ayni modulde gezerken her seferinde bastan basla masin.
  useEffect(() => {
    if (!openMobileDrawer) return;
    setDrawerModule((onceki) => {
      if (onceki) return onceki;
      return selectedModule && categories[selectedModule]?.length > 0 ? selectedModule : null;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openMobileDrawer]);

  const categories = {
    'YENİ İŞLEM': ['YENİ İŞLEM', 'HIZLI İŞLEM'],
    'İŞLEMLER': ['TÜM İŞLEMLER'],
    'MÜŞTERİLER': ['MÜŞTERİ EKLE', 'MÜŞTERİ LİSTESİ', 'TESLİMAT LİSTESİ', 'MÜŞTERİ BAKİYELERİ'], 
    'FİRMALAR': ['FİRMA EKLE', 'FİRMA LİSTESİ'],
    'KASA': ['GÜNSONU KASA', 'MEVCUT KASA', 'ÖNCEKİ KASA', 'GEÇMİŞ KASA ARA', 'BANKA'],
    'RAPORLAR': (activePersonel?.yetkiler?.ozelIzinler?.raporGoruntuleme || activePersonel?.rol === 'admin') 
      ? ['GÜNLÜK RAPORLAR', 'HAFTALIK RAPORLAR', 'AYLIK RAPORLAR', 'RAPOR OLUŞTUR']
      : [],
    'YÖNETİCİ': isAdminAuthenticated
      ? [
          'KULLANICI YÖNETİMİ',
          'PERSONEL YÖNETİMİ',
          'ŞUBE YÖNETİMİ',
          'FİRMA BAKİYELER',
          'ÖZEL RAPORLAR',
          'MAĞAZA DURUMU',
          'BİLDİRİM YÖNETİMİ',
          'WHATSAPP AYARLARI',
          'FİNANS'
        ]
      : [],
    'ŞUBE': ['ŞUBE BİLGİLERİ', 'ŞUBE DEĞİŞTİR'],
    'SARRAF': ['GÜNCEL FİYAT EKRANI', 'REFERANS FİYAT EKRANI'],
    'ÜRÜNLER': ['ÜRÜN EKLE', 'ÜRÜN LİSTESİ'],
    'ÇIKIŞ': []
  };

  const categoryComponents = {
    'YENİ İŞLEM': YeniIslem,
    'HIZLI İŞLEM': HizliIslem,
    'TÜM İŞLEMLER': TumIslemler,
    'MÜŞTERİ EKLE': MusteriEkle,
    'MÜŞTERİ LİSTESİ': MusteriListesi,
    'TESLİMAT LİSTESİ': TeslimatListesi,
    'MÜŞTERİ BAKİYELERİ': MusteriBakiyeler, 
    'FİRMA EKLE': FirmaEkle,
    'FİRMA LİSTESİ': FirmaListesi,
    'GÜNSONU KASA': GunsonuKasa,
    'MEVCUT KASA': MevcutKasa,
    'ÖNCEKİ KASA': OncekiKasa,
    'GEÇMİŞ KASA ARA': GecmisKasaAra,
    'BANKA': Banka,
    'GÜNLÜK RAPORLAR': GunlukRaporlar,
    'HAFTALIK RAPORLAR': HaftalikRaporlar,
    'AYLIK RAPORLAR': AylikRaporlar,
    'RAPOR OLUŞTUR': RaporOlustur,
    'FİNANS': FinansPage,
    'KULLANICI YÖNETİMİ': KullaniciYonetimi,
    'PERSONEL YÖNETİMİ': PersonelYonetimi,
    'ŞUBE YÖNETİMİ': SubeYonetimi,
    'FİRMA BAKİYELER': FirmaBakiyeler,
    'ÖZEL RAPORLAR': OzelRaporlar,
    'MAĞAZA DURUMU': MagazaDurumu,
    'BİLDİRİM YÖNETİMİ': BildirimYonetimi,
    'WHATSAPP AYARLARI': WhatsappAyarlari,
    'ŞUBE BİLGİLERİ': SubeBilgileri,
    'ŞUBE DEĞİŞTİR': SubeDegistir,
    'GÜNCEL FİYAT EKRANI': GuncelFiyatEkrani,
    'REFERANS FİYAT EKRANI': ReferansFiyatEkrani,
    'ÜRÜN EKLE': Urunekle,
    'ÜRÜN LİSTESİ': UrunListesi,
  };

  const handleModuleClick = useCallback((module) => {
    if (module === 'ÇIKIŞ') {
      setShowExitModal(true);
    } else if (module === 'YÖNETİCİ') {
      setShowAdminDialog(true);
    } else if (module === 'RAPORLAR' && (!activePersonel?.yetkiler?.ozelIzinler?.raporGoruntuleme && activePersonel?.rol !== 'admin')) {
      alert("Bu menüye giriş yetkiniz bulunmuyor!");
    } else {
      setSelectedModule(module);
      setSelectedCategory(null);
    }
  }, [activePersonel]);

  const handleCategoryClick = useCallback((category) => {
    setSelectedCategory(category);
  }, []);

  const handleLogoClick = useCallback(() => {
    setSelectedModule(null);
    setSelectedCategory(null);
    navigate(`/dashboard?sube=${sube}`);
  }, [navigate, sube]);

  const clearSessionAndSignOut = useCallback(async () => {
    localStorage.removeItem('aktifPersonel');
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Oturum kapatma hatası:', error);
    }
  }, []);

  const handleExitConfirm = useCallback(async () => {
    setShowExitModal(false);
    await clearSessionAndSignOut();
    navigate('/giris', { replace: true });
  }, [clearSessionAndSignOut, navigate]);

  const handleLockSession = useCallback(async () => {
    await clearSessionAndSignOut();
    navigate(`/subegirisi?sube=${sube}`, { replace: true });
  }, [clearSessionAndSignOut, navigate, sube]);

  useEffect(() => {
    const onHistoryNavigation = () => {
      handleLockSession();
    };
    window.addEventListener('popstate', onHistoryNavigation);
    return () => {
      window.removeEventListener('popstate', onHistoryNavigation);
    };
  }, [handleLockSession]);

  const handleExitCancel = useCallback(() => {
    setShowExitModal(false);
    setSelectedModule(null);
    setSelectedCategory(null);
    navigate(`/dashboard?sube=${sube}`);
  }, [navigate, sube]);

  const formatTime = (date) => {
    return date.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
  };
  
  const formatDate = (date) => {
    return date.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' });
  };
  
  const formatDay = (date) => {
    return date.toLocaleDateString('tr-TR', { weekday: 'long' }).toUpperCase();
  };

  const subeAdi = {
    'sefakoy_merkez': 'Sefaköy Merkez Mağaza',
    'sefakoy_sube': 'Sefaköy Şube Mağaza',
    'kavakli_sube': 'Kavaklı Şube Mağaza',
    'Bilinmeyen Şube': 'Bilinmeyen Şube'
  };

  const SelectedComponent = selectedCategory ? categoryComponents[selectedCategory] : null;

  const actions = [
    { icon: <CalculateIcon />, name: 'Hesap Makinesi', action: () => setOpenHesap(true), color: '#9c27b0' },
    { icon: <EventIcon />, name: 'Ajanda', action: () => setOpenAjanda(true), color: '#ed6c02' },
    { icon: <PointOfSaleIcon />, name: 'POS Hesaplayıcı', action: () => setOpenPos(true), color: '#2e7d32' }, // YENİ EKLENDİ
    { icon: <NotificationsIcon />, name: 'Bildirimler', action: () => setOpenBildirim(true), color: '#1976d2' },
  ];

  if (!activePersonel) return null; 

  return (
    <PriceProvider>
      <div
        className="dashboard-root"
        style={{
          position: 'relative',
          display: 'grid',
          gridTemplateColumns: '250px 1fr',
          gridTemplateRows: '150px 1fr',
          height: '100vh',
          background:
            'linear-gradient(160deg, #070a0f 0%, #0c1118 38%, #101820 72%, #0a0d12 100%)',
          fontFamily:
            "'Inter', 'SF Pro Text', 'Helvetica Neue', system-ui, -apple-system, sans-serif",
          overflow: 'hidden',
          boxSizing: 'border-box'
        }}
      >
        {/* MOBİL ÜST BAR (sadece mobil CSS ile görünür) */}
        <div className="dashboard-mobile-topbar">
          {/* Tek satir: solda kompakt menu, ortada logo, sagda saat/tarih. */}
          <div className="dashboard-mobile-toprow">
            <button
              type="button"
              className="dashboard-mobile-menu-btn"
              onClick={() => setOpenMobileDrawer(true)}
              aria-label="Menü"
            >
              <MenuIcon sx={{ fontSize: 20 }} />
              <span className="dashboard-mobile-menu-label">Menü</span>
            </button>

            <button
              type="button"
              className="dashboard-mobile-logo"
              onClick={handleLogoClick}
              aria-label="Anasayfa"
            >
              <img src={Logo} alt="UKBA Kasa Logo" />
            </button>

            <div className="dashboard-mobile-clock">
              <div className="dashboard-mobile-time">{formatTime(currentTime)}</div>
              <div className="dashboard-mobile-date">{formatDate(currentTime)}</div>
              <div className="dashboard-mobile-day">{formatDay(currentTime)}</div>
            </div>
          </div>
        </div>

        <Drawer
          anchor="left"
          open={openMobileDrawer}
          onClose={() => setOpenMobileDrawer(false)}
          PaperProps={{
            sx: {
              width: 320,
              maxWidth: '86vw',
              bgcolor: '#0b1016',
              color: '#e5e7eb'
            }
          }}
        >
          <Stack spacing={1} sx={{ px: 1.5, pt: 1.5, pb: 1 }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 11, letterSpacing: '0.22em', textTransform: 'uppercase', color: 'rgba(212,175,98,0.75)', fontWeight: 800 }}>
                  Mağaza
                </span>
                <span style={{ fontSize: 16, fontWeight: 700, color: '#f4f1eb' }}>{subeAdi[sube]}</span>
              </div>
              <IconButton
                size="small"
                onClick={() => setOpenMobileDrawer(false)}
                sx={{ color: 'rgba(212,175,98,0.95)', border: '1px solid rgba(212,175,98,0.25)' }}
              >
                ✕
              </IconButton>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 10px', borderRadius: 12, background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.10)' }}>
              <Avatar sx={{ width: 34, height: 34, bgcolor: 'rgba(212, 175, 98, 0.15)', color: '#f5e6c8', fontSize: 13, fontWeight: 800, border: '1px solid rgba(212, 175, 98, 0.35)' }}>
                {activePersonel.isim.charAt(0)}
                {activePersonel.soyisim.charAt(0)}
              </Avatar>
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 13, fontWeight: 700, color: '#f1f5f9' }}>
                  {activePersonel.isim} {activePersonel.soyisim}
                </span>
                <span style={{ fontSize: 10, color: 'rgba(148, 163, 184, 0.95)', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
                  {activePersonel.rol === 'admin' ? 'Yönetici' : 'Personel'}
                </span>
              </div>
              <Tooltip title="Oturumu Kilitle (Personel Değiştir)">
                <IconButton
                  size="small"
                  onClick={() => {
                    setOpenMobileDrawer(false);
                    handleLockSession();
                  }}
                  sx={{
                    ml: 'auto',
                    color: 'rgba(212, 175, 98, 0.95)',
                    bgcolor: 'rgba(212, 175, 98, 0.08)',
                    border: '1px solid rgba(212, 175, 98, 0.25)',
                    '&:hover': { bgcolor: 'rgba(212, 175, 98, 0.16)' }
                  }}
                >
                  <LockOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </div>
          </Stack>

          {/* --- SEVIYE 1: Hizli Islemler + Moduller --- */}
          {!drawerModule ? (
            <>
          <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

          {/* Hizli islemler: onceden mobil ust barda duran Faturalar / Canli Banka /
              Kampanya butonlari. Anasayfanin tepesini isgal etmemeleri icin cekmeceye
              tasindi. Sadece kompakt (telefon/tablet) duzende gorunur, cunku cekmecenin
              kendisi masaustunde hic acilmaz. */}
          <List
            dense
            subheader={
              <ListSubheader component="div" sx={{ bgcolor: 'transparent', color: 'rgba(226,232,240,0.9)', fontWeight: 900, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
                Hızlı İşlemler
              </ListSubheader>
            }
          >
            {[
              { label: 'Faturalar', accent: 'rgba(16, 185, 129, 0.55)', tint: 'rgba(16, 185, 129, 0.10)', open: setOpenInvoiceModal },
              { label: 'Canlı Banka', accent: 'rgba(59, 130, 246, 0.55)', tint: 'rgba(59, 130, 246, 0.10)', open: setOpenLiveBankModal },
              { label: 'Kampanya Yönetimi', accent: 'rgba(212, 175, 98, 0.55)', tint: 'rgba(212, 175, 98, 0.10)', open: setOpenCampaignModal }
            ].map((item) => (
              <ListItemButton
                key={item.label}
                onClick={() => {
                  setOpenMobileDrawer(false);
                  item.open(true);
                }}
                sx={{
                  mx: 1,
                  my: 0.25,
                  minHeight: 46,
                  borderRadius: 1.5,
                  color: '#e5e7eb',
                  bgcolor: item.tint,
                  borderLeft: `3px solid ${item.accent}`,
                  '&:hover': { bgcolor: item.tint }
                }}
              >
                <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 800, fontSize: 13 }} />
              </ListItemButton>
            ))}
          </List>

          <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

          <List
            dense
            subheader={
              <ListSubheader component="div" sx={{ bgcolor: 'transparent', color: 'rgba(226,232,240,0.9)', fontWeight: 900, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
                Modüller
              </ListSubheader>
            }
          >
            {displayedModules.map((module) => (
              <ListItemButton
                key={module}
                selected={selectedModule === module}
                onClick={() => {
                  // ÇIKIŞ / YÖNETİCİ modal actigi icin cekmece kapanir.
                  if (module === 'ÇIKIŞ' || module === 'YÖNETİCİ') setOpenMobileDrawer(false);
                  handleModuleClick(module);
                  // Kategorisi olan moduller cekmecenin 2. seviyesini acar; liste
                  // kategorilerle DEGISIR, alta eklenmez.
                  if (categories[module]?.length > 0) setDrawerModule(module);
                }}
                sx={{
                  mx: 1,
                  my: 0.25,
                  borderRadius: 1.5,
                  color: '#e5e7eb',
                  '&.Mui-selected': { bgcolor: 'rgba(212,175,98,0.18)' },
                  '&.Mui-selected:hover': { bgcolor: 'rgba(212,175,98,0.22)' }
                }}
              >
                <ListItemText primary={module} primaryTypographyProps={{ fontWeight: 800, fontSize: 13 }} />
              </ListItemButton>
            ))}
          </List>
            </>
          ) : null}

          {/* --- SEVIYE 2: secilen modulun kategorileri --- */}
          {drawerModule && categories[drawerModule]?.length > 0 ? (
            <>
              <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

              <ListItemButton
                onClick={() => setDrawerModule(null)}
                sx={{
                  // Cekmece govdesi flex sutun; ListItemButton varsayilan
                  // flex-grow: 1 ile 439px'e uzayip devasa bosluk biraikiyordu.
                  flexGrow: 0,
                  flexShrink: 0,
                  mx: 1,
                  my: 0.5,
                  minHeight: 48,
                  borderRadius: 1.5,
                  color: 'rgba(245,230,200,0.95)'
                }}
              >
                <ArrowBackIcon sx={{ fontSize: 18, mr: 1 }} />
                <ListItemText
                  primary={drawerModule}
                  secondary="Menüye dön"
                  primaryTypographyProps={{ fontWeight: 900, fontSize: 13, letterSpacing: '0.06em' }}
                  secondaryTypographyProps={{ fontSize: 11, color: 'rgba(148,163,184,0.9)' }}
                />
              </ListItemButton>

              <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />

              <List dense>
                {categories[drawerModule].map((cat) => (
                  <ListItemButton
                    key={cat}
                    selected={selectedCategory === cat}
                    onClick={() => {
                      setSelectedCategory(cat);
                      setOpenMobileDrawer(false);
                    }}
                    sx={{
                      mx: 1,
                      my: 0.25,
                      minHeight: 44,
                      borderRadius: 1.5,
                      color: 'rgba(226,232,240,0.92)',
                      '&.Mui-selected': { bgcolor: 'rgba(59,130,246,0.18)' },
                      '&.Mui-selected:hover': { bgcolor: 'rgba(59,130,246,0.22)' }
                    }}
                  >
                    <ListItemText primary={cat} primaryTypographyProps={{ fontWeight: 700, fontSize: 12.5 }} />
                  </ListItemButton>
                ))}
              </List>
            </>
          ) : null}
        </Drawer>

        {/* Logo Alanı */}
        <div
          className="dashboard-logo-wrap"
          style={{
            position: 'relative',
            zIndex: 1,
            gridColumn: '1 / 2',
            gridRow: '1 / 2',
            height: '100%',
            minHeight: 0,
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background:
              'linear-gradient(165deg, rgba(28, 32, 38, 0.95) 0%, rgba(18, 22, 28, 0.98) 100%)',
            boxShadow:
              '0 24px 48px rgba(0, 0, 0, 0.45), inset 0 1px 0 rgba(255,255,255,0.06), inset 0 0 0 1px rgba(212, 175, 98, 0.12)',
            borderRadius: '16px',
            margin: '10px',
            border: '1px solid rgba(212, 175, 98, 0.18)',
            padding: '12px'
          }}
        >
          <img
            src={Logo}
            alt="UKBA Kasa Logo"
            style={{
              width: '108px',
              height: '108px',
              maxWidth: 'calc(100% - 8px)',
              maxHeight: 'calc(100% - 8px)',
              objectFit: 'contain',
              borderRadius: '12px',
              cursor: 'pointer',
              boxShadow:
                '0 4px 6px rgba(0,0,0,0.18), 0 14px 36px rgba(0,0,0,0.42), 0 0 0 1px rgba(0,0,0,0.12), 0 0 40px rgba(212, 175, 98, 0.12)',
              border: '1px solid rgba(212, 175, 98, 0.2)',
              background: 'linear-gradient(180deg, #faf8f4 0%, #f0ebe3 100%)',
              padding: '8px',
              boxSizing: 'border-box',
              filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.35))'
            }}
            onClick={handleLogoClick}
          />
        </div>

        {/* Menü Alanı (Header) */}
        <div
          className="dashboard-header"
          style={{
            position: 'relative',
            zIndex: 1,
            gridColumn: '2 / 3',
            gridRow: '1 / 2',
            height: '100%',
            minHeight: 0,
            boxSizing: 'border-box',
            background:
              'linear-gradient(145deg, #141a22 0%, #0e1218 45%, #0a0d11 100%)',
            boxShadow:
              '0 24px 56px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255,255,255,0.04)',
            borderRadius: '16px',
            margin: '10px',
            padding: '14px 24px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'stretch',
            gap: '20px',
            overflow: 'hidden',
            border: '1px solid rgba(212, 175, 98, 0.14)',
            color: '#e8eaed'
          }}
        >
          {/* SOL TARAFTAKİ BLOK (Bilgiler + Butonlar) */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              flex: 1,
              minWidth: 0
            }}
          >
            {/* Üst Satır: Şube + Personel */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '18px', flexWrap: 'wrap' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', minWidth: 0 }}>
                <span
                  style={{
                    fontSize: '10px',
                    fontWeight: 700,
                    letterSpacing: '0.28em',
                    color: 'rgba(212, 175, 98, 0.7)',
                    textTransform: 'uppercase'
                  }}
                >
                  Mağaza
                </span>
                <div
                  style={{
                    fontSize: '21px',
                    fontWeight: 500,
                    color: '#f4f1eb',
                    letterSpacing: '0.01em',
                    lineHeight: 1.25,
                    fontFamily: "Georgia, 'Times New Roman', serif",
                    paddingBottom: '4px',
                    borderBottom: '1px solid rgba(212, 175, 98, 0.28)',
                    maxWidth: '100%'
                  }}
                >
                  {subeAdi[sube]}
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'rgba(255,255,255,0.04)',
                  padding: '7px 16px 7px 12px',
                  borderRadius: '999px',
                  border: '1px solid rgba(255,255,255,0.08)',
                  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
                  borderLeft: '3px solid rgba(212, 175, 98, 0.55)'
                }}
              >
                <Avatar
                  sx={{
                    width: 36,
                    height: 36,
                    bgcolor: 'rgba(212, 175, 98, 0.15)',
                    color: '#f5e6c8',
                    fontSize: 14,
                    fontWeight: 700,
                    border: '1px solid rgba(212, 175, 98, 0.35)'
                  }}
                >
                  {activePersonel.isim.charAt(0)}
                  {activePersonel.soyisim.charAt(0)}
                </Avatar>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <span style={{ fontSize: '13px', fontWeight: 600, color: '#f1f5f9', letterSpacing: '0.02em' }}>
                    {activePersonel.isim} {activePersonel.soyisim}
                  </span>
                  <span style={{ fontSize: '10px', color: 'rgba(148, 163, 184, 0.95)', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase' }}>
                    {activePersonel.rol === 'admin' ? 'Yönetici' : 'Personel'}
                  </span>
                </div>
                <Tooltip title="Oturumu Kilitle (Personel Değiştir)">
                  <IconButton
                    size="small"
                    onClick={handleLockSession}
                    sx={{
                      ml: 0.5,
                      color: 'rgba(212, 175, 98, 0.95)',
                      bgcolor: 'rgba(212, 175, 98, 0.08)',
                      border: '1px solid rgba(212, 175, 98, 0.25)',
                      '&:hover': { bgcolor: 'rgba(212, 175, 98, 0.16)' }
                    }}
                  >
                    <LockOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            </div>

            {/* Alt Satır: Menü Butonları */}
            <div
              className="dashboard-mod-row"
              style={{
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap',
                alignItems: 'center',
                marginTop: '10px',
                paddingTop: '12px',
                borderTop: '1px solid rgba(255,255,255,0.06)'
              }}
            >
              {displayedModules.map((module) => (
                <button
                  key={module}
                  type="button"
                  className="dashboard-mod-btn"
                  data-active={selectedModule === module ? 'true' : 'false'}
                  style={{
                    opacity:
                      module === 'RAPORLAR' &&
                      !activePersonel?.yetkiler?.ozelIzinler?.raporGoruntuleme &&
                      activePersonel?.rol !== 'admin'
                        ? 0.48
                        : 1
                  }}
                  onClick={() => handleModuleClick(module)}
                >
                  {module}
                </button>
              ))}
            </div>
          </div>

          {/* Hizli erisim: masaustunde saatin solunda tek sira, dar pencerede alt satira iner */}
          <div
            className="dashboard-quick-row"
            style={{
              position: 'absolute',
              right: '246px',
              top: '12px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              zIndex: 3
            }}
          >
            <button
              type="button"
              onClick={() => setOpenInvoiceModal(true)}
              style={{
                width: '130px',
                minWidth: '130px',
                height: '40px',
                borderRadius: '12px',
                border: '1px solid rgba(16, 185, 129, 0.52)',
                background: 'linear-gradient(170deg, #134e3a 0%, #0f2922 55%, #0b1f18 100%)',
                color: '#d1fae5',
                fontSize: '12px',
                fontWeight: 800,
                letterSpacing: '0.03em',
                lineHeight: 1,
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '7px',
                cursor: 'pointer',
                boxShadow: '0 0 0 rgba(16,185,129,0), inset 0 1px 0 rgba(255,255,255,0.06)',
                transition: 'all 220ms ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 0 18px rgba(16,185,129,0.35), inset 0 1px 0 rgba(255,255,255,0.08)';
                e.currentTarget.style.borderColor = 'rgba(52,211,153,0.8)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 0 0 rgba(16,185,129,0), inset 0 1px 0 rgba(255,255,255,0.06)';
                e.currentTarget.style.borderColor = 'rgba(16, 185, 129, 0.52)';
              }}
            >
              <DescriptionIcon sx={{ fontSize: 16 }} />
              Faturalar
            </button>

            <button
              type="button"
              onClick={() => {
                setOpenLiveBankModal(true);
              }}
              style={{
                width: '150px',
                minWidth: '150px',
                height: '40px',
                borderRadius: '12px',
                border: '1px solid rgba(59, 130, 246, 0.52)',
                background: 'linear-gradient(170deg, #14253d 0%, #0f172a 55%, #0b1320 100%)',
                color: '#dbeafe',
                fontSize: '12px',
                fontWeight: 800,
                letterSpacing: '0.03em',
                lineHeight: 1,
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '7px',
                cursor: 'pointer',
                boxShadow: '0 0 0 rgba(59,130,246,0), inset 0 1px 0 rgba(255,255,255,0.06)',
                transition: 'all 220ms ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 0 18px rgba(59,130,246,0.35), inset 0 1px 0 rgba(255,255,255,0.08)';
                e.currentTarget.style.borderColor = 'rgba(96,165,250,0.8)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 0 0 rgba(59,130,246,0), inset 0 1px 0 rgba(255,255,255,0.06)';
                e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.52)';
              }}
            >
              Canlı Banka
            </button>            <button
              type="button"
              onClick={() => setOpenCampaignModal(true)}
              style={{
                width: '172px',
                minWidth: '172px',
                height: '40px',
                borderRadius: '12px',
                border: '1px solid rgba(212, 175, 98, 0.52)',
                background: 'linear-gradient(170deg, #181f29 0%, #0f141d 55%, #0b1016 100%)',
                color: '#f5e6c8',
                fontSize: '12px',
                fontWeight: 800,
                letterSpacing: '0.03em',
                lineHeight: 1,
                padding: '0 12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '7px',
                cursor: 'pointer',
                boxShadow: '0 0 0 rgba(212,175,98,0), inset 0 1px 0 rgba(255,255,255,0.06)',
                transition: 'all 220ms ease'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-1px)';
                e.currentTarget.style.boxShadow = '0 0 18px rgba(212,175,98,0.35), inset 0 1px 0 rgba(255,255,255,0.08)';
                e.currentTarget.style.borderColor = 'rgba(212,175,98,0.8)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 0 0 rgba(212,175,98,0), inset 0 1px 0 rgba(255,255,255,0.06)';
                e.currentTarget.style.borderColor = 'rgba(212, 175, 98, 0.52)';
              }}
            >
              <RocketLaunchIcon sx={{ fontSize: 16 }} />
              Kampanya Yönetimi
            </button>
          </div>

          {/* SAĞ TARAFTAKİ BLOK (DEV SAAT KUTUSU) */}
          <div>
            <div
              className="dashboard-clock"
              style={{
                width: '188px',
                minWidth: '188px',
                alignSelf: 'stretch',
                minHeight: '100%',
                boxSizing: 'border-box',
                background:
                  'radial-gradient(ellipse 120% 80% at 50% 0%, rgba(212, 175, 98, 0.12) 0%, transparent 55%), linear-gradient(165deg, #1a1f26 0%, #0d1014 100%)',
                color: '#fff',
                boxShadow:
                  '0 20px 40px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.05), inset 0 0 0 1px rgba(212, 175, 98, 0.2)',
                borderRadius: '16px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                border: '1px solid rgba(212, 175, 98, 0.22)',
                padding: '18px 14px'
              }}
            >
              <div
                style={{
                  fontSize: '44px',
                  fontWeight: 300,
                  letterSpacing: '0.1em',
                  lineHeight: 1,
                  fontVariantNumeric: 'tabular-nums',
                  color: '#faf8f3',
                  textShadow: '0 2px 20px rgba(0,0,0,0.45)'
                }}
              >
                {formatTime(currentTime)}
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginTop: '6px',
                  gap: '3px'
                }}
              >
                <span style={{ fontSize: '19px', color: 'rgba(226, 232, 240, 0.95)', fontWeight: 600, textAlign: 'center', lineHeight: 1.2 }}>
                  {formatDate(currentTime)}
                </span>
                <span
                  style={{
                    fontSize: '16px',
                    fontWeight: 700,
                    color: 'rgba(212, 175, 98, 0.98)',
                    letterSpacing: '0.16em',
                    textAlign: 'center',
                    lineHeight: 1.15
                  }}
                >
                  {formatDay(currentTime)}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* --- MODALLAR VE DİĞER KISIMLAR --- */}
        <Dialog open={showAdminDialog} onClose={handleAdminDialogClose}>
          <DialogTitle style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 'bold' }}>
            Yönetici Girişi
          </DialogTitle>
          <DialogContent>
            {adminError && (
              <Alert severity="error" style={{ marginBottom: '10px' }}>
                {adminError}
              </Alert>
            )}
            <TextField
              label="E-posta"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fullWidth
              style={{ marginBottom: '10px', marginTop: '10px' }}
              InputProps={{ style: { fontSize: '14px' } }}
              InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: 'bold' } }}
            />
            <TextField
              label="Şifre"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
              style={{ marginBottom: '10px' }}
              InputProps={{ style: { fontSize: '14px' } }}
              InputLabelProps={{ style: { fontFamily: "'Roboto', sans-serif", fontWeight: 'bold' } }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleAdminDialogClose} color="error">İptal</Button>
            <Button onClick={handleAdminLogin} color="success" variant="contained">GİRİŞ</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={showExitModal} onClose={handleExitCancel}>
          <DialogTitle style={{ fontFamily: "'Roboto', sans-serif", fontWeight: 'bold' }}>
            Çıkış Yap
          </DialogTitle>
          <DialogContent>
            <p style={{ fontSize: '18px', color: '#000' }}>
              Çıkış yapmak istediğinize emin misiniz?
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleExitCancel} color="error">İptal</Button>
            <Button onClick={handleExitConfirm} sx={{ bgcolor: '#000', color: '#fff', '&:hover': { bgcolor: '#333' } }}>Çıkış Yap</Button>
          </DialogActions>
        </Dialog>

        <CampaignModal open={openCampaignModal} onClose={() => setOpenCampaignModal(false)} />
        <LiveBankModal open={openLiveBankModal} onClose={() => setOpenLiveBankModal(false)} sube={sube} />
        <InvoiceModal open={openInvoiceModal} onClose={() => setOpenInvoiceModal(false)} sube={sube} />

        <div
          className="dashboard-sidebar"
          style={{
            position: 'relative',
            zIndex: 1,
            gridColumn: '1 / 2',
            gridRow: '2 / 3',
            background:
              'linear-gradient(180deg, rgba(250, 248, 244, 0.97) 0%, rgba(238, 234, 227, 0.95) 100%)',
            boxShadow:
              '0 20px 48px rgba(0, 0, 0, 0.35), inset 0 1px 0 rgba(255,255,255,0.65)',
            borderRadius: '16px',
            margin: '10px',
            padding: '14px 12px',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            overflow: 'auto',
            border: '1px solid rgba(212, 175, 98, 0.2)',
            color: '#2a2620'
          }}
        >
          {selectedModule && categories[selectedModule]?.length > 0 ? (
            <>
              <div className="dashboard-sidebar-label">Kategoriler</div>
              {categories[selectedModule].map((category) => (
              <button
                key={category}
                type="button"
                className="dashboard-cat-btn"
                data-active={selectedCategory === category ? 'true' : 'false'}
                onClick={() => handleCategoryClick(category)}
              >
                {category}
              </button>
              ))}
            </>
          ) : (
            <p className="dashboard-hint">
              Kategori seçmek için bir modül seçin.
            </p>
          )}
        </div>

        <div
          className="dashboard-content"
          style={{
            position: 'relative',
            zIndex: 1,
            gridColumn: '2 / 3',
            gridRow: '2 / 3',
            background: selectedCategory === 'FİNANS'
              ? '#f4f6f9'
              : 'linear-gradient(180deg, rgba(252, 251, 248, 0.98) 0%, rgba(244, 241, 235, 0.96) 100%)',
            boxShadow:
              '0 20px 48px rgba(0, 0, 0, 0.32), inset 0 1px 0 rgba(255,255,255,0.7)',
            borderRadius: '16px',
            margin: '10px',
            padding: selectedCategory === 'FİNANS' ? '12px' : '22px',
            overflow: 'hidden',
            border: selectedCategory === 'FİNANS'
              ? '1px solid #e5eaf0'
              : '1px solid rgba(212, 175, 98, 0.16)',
            color: '#1a1814',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0
          }}
        >
          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              overflow: selectedCategory === 'FİNANS' ? 'hidden' : 'auto'
            }}
          >
            {selectedModule && selectedCategory && SelectedComponent ? (
              <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: selectedCategory === 'FİNANS' ? 'hidden' : 'auto' }}>
                <SelectedComponent sube={sube} activePersonel={activePersonel} branchAuthIsAdmin={branchAuthIsAdmin} />
              </Box>
            ) : (
              <p className="dashboard-placeholder">
                {selectedModule ? (
                  selectedCategory ? (
                    `${selectedModule} - ${selectedCategory} işlemleri burada görünecek.`
                  ) : (
                    `${selectedModule} modülü seçildi, kategori seçin.`
                  )
                ) : (
                  'Lütfen bir modül seçin.'
                )}
              </p>
            )}
          </div>
        </div>

        {sube && (
          <Box
            sx={{
              position: 'fixed',
              bottom: { xs: 16, md: 30 },
              right: { xs: 12, md: 30 },
              zIndex: 1000,
              pointerEvents: 'none',
              width: 'max-content',
              maxWidth: '100%',
            }}
          >
            <SpeedDial
              ariaLabel="Hızlı Araçlar"
              icon={<SpeedDialIcon />}
              direction="up"
              FabProps={{
                sx: {
                  width: 40,
                  height: 40,
                  minHeight: 40,
                  bgcolor: '#0a0d11',
                  color: 'rgba(245, 230, 200, 0.95)',
                  boxShadow: '0 16px 40px rgba(0,0,0,0.55), inset 0 1px 0 rgba(255,255,255,0.06)',
                  border: '1px solid rgba(212, 175, 98, 0.45)',
                  '&:hover': { bgcolor: '#121820' }
                }
              }}
            >
              {actions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  onClick={action.action}
                  FabProps={{ sx: { bgcolor: action.color, color: 'white', '&:hover': { bgcolor: action.color } } }}
                />
              ))}
            </SpeedDial>
            {/* Hızlı Menü Bileşenleri */}
            {openBildirim && <BildirimKutusu sube={sube} forceOpen={true} onClose={() => setOpenBildirim(false)} />}
            {openAjanda && <AjandaKutusu sube={sube} forceOpen={true} onClose={() => setOpenAjanda(false)} />}
            {openHesap && <HesapMakinesiKutusu sube={sube} forceOpen={true} onClose={() => setOpenHesap(false)} />}
            {openPos && <PosCihaziKutusu sube={sube} forceOpen={true} onClose={() => setOpenPos(false)} />}
          </Box>
        )}

        <style>{`
          .dashboard-root::before {
            content: "";
            position: absolute;
            inset: 0;
            pointer-events: none;
            z-index: 0;
            background:
              radial-gradient(ellipse 90% 55% at 50% -15%, rgba(212, 175, 98, 0.09) 0%, transparent 52%),
              radial-gradient(ellipse 50% 45% at 100% 100%, rgba(80, 110, 140, 0.12) 0%, transparent 50%),
              radial-gradient(ellipse 40% 35% at 0% 80%, rgba(212, 175, 98, 0.04) 0%, transparent 45%);
          }
          .dashboard-sidebar-label {
            font-size: 10px;
            font-weight: 700;
            letter-spacing: 0.26em;
            text-transform: uppercase;
            color: rgba(71, 63, 52, 0.55);
            margin: 0 2px 4px 2px;
            padding-bottom: 8px;
            border-bottom: 1px solid rgba(212, 175, 98, 0.22);
          }
          .dashboard-mod-btn {
            position: relative;
            /* Eskiden "flex: 1" ile hepsi esit genislige zorlaniyordu; uzun yazilar
               (MUSTERILER) kutusuna sigmayip yan butonun uzerine tasiyordu.
               Artik her buton yazisi kadar yer kaplar. */
            flex: 0 0 auto;
            white-space: nowrap;
            min-width: 100px;
            max-width: 172px;
            height: 48px;
            padding: 0 8px;
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            border-radius: 8px;
            border: 1px solid rgba(255, 255, 255, 0.12);
            color: rgba(248, 250, 252, 0.88);
            cursor: pointer;
            background: rgba(255, 255, 255, 0.04);
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.04);
            transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
          }
          .dashboard-mod-btn::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: 3px;
            transform: translateX(-50%);
            width: 46%;
            max-width: 72px;
            height: 2px;
            border-radius: 2px;
            background: linear-gradient(90deg, transparent, rgba(212, 175, 98, 0.45), transparent);
            opacity: 0.85;
            pointer-events: none;
          }
          .dashboard-mod-btn:hover {
            transform: translateY(-1px);
            background: rgba(255, 255, 255, 0.08);
            border-color: rgba(212, 175, 98, 0.35);
            color: #fff;
          }
          .dashboard-mod-btn:hover::after {
            background: linear-gradient(90deg, transparent, rgba(212, 175, 98, 0.75), transparent);
          }
          .dashboard-mod-btn[data-active="true"] {
            background: linear-gradient(180deg, #f7f2ea 0%, #ebe4d8 100%);
            color: #0a0d11;
            border-color: rgba(212, 175, 98, 0.55);
            box-shadow:
              0 0 0 1px rgba(212, 175, 98, 0.25),
              0 10px 28px rgba(0, 0, 0, 0.35),
              inset 0 1px 0 rgba(255,255,255,0.85);
          }
          .dashboard-mod-btn[data-active="true"]::after {
            bottom: 4px;
            width: 58%;
            max-width: 88px;
            background: linear-gradient(90deg, transparent, rgba(120, 90, 40, 0.55), transparent);
            opacity: 1;
          }
          .dashboard-cat-btn {
            width: 100%;
            padding: 9px 14px;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            border-radius: 10px;
            border: 1px solid rgba(26, 24, 20, 0.08);
            color: rgba(42, 38, 32, 0.88);
            cursor: pointer;
            text-align: left;
            background: rgba(255, 255, 255, 0.55);
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease;
          }
          .dashboard-cat-btn:hover {
            transform: translateX(2px);
            background: rgba(255, 255, 255, 0.85);
            border-color: rgba(212, 175, 98, 0.35);
            box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
          }
          .dashboard-cat-btn[data-active="true"] {
            background: linear-gradient(90deg, rgba(10, 13, 17, 0.96) 0%, rgba(28, 32, 38, 0.94) 100%);
            color: #f4f1eb;
            border-color: rgba(212, 175, 98, 0.45);
            box-shadow:
              inset 3px 0 0 rgba(212, 175, 98, 0.85),
              0 8px 24px rgba(0, 0, 0, 0.18);
          }
          .dashboard-hint,
          .dashboard-placeholder {
            margin: 0;
            font-size: 14px;
            line-height: 1.65;
            color: rgba(71, 63, 52, 0.72);
            font-weight: 500;
            padding: 20px 18px;
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(212, 175, 98, 0.2);
            font-family: Georgia, 'Times New Roman', serif;
          }
          .MuiSpeedDialAction-fab {
            width: 60px !important;
            height: 60px !important;
            margin-bottom: 10px !important;
          }
          .MuiSpeedDialAction-fab svg {
            font-size: 30px !important;
          }

          /* Mobil üst bar varsayılan: gizli (masaüstünü bozmasın). */
          .dashboard-mobile-topbar {
            display: none;
          }

          /* --- DAR MASAUSTU (1100-1649px, fare) ---
             Menu seridi dogal halinde ~1400px istiyor; bu araliktaki pencerelerde
             ust uste binmemesi icin sol sutun, buton ve saat kuculuyor. Duzen
             aynen masaustu: serit tek satirda kaliyor, alt satira kirilmiyor. */
          @media (min-width: 1100px) and (max-width: 1649px) and (any-pointer: fine) {
            .dashboard-root {
              grid-template-columns: 172px 1fr !important;
              grid-template-rows: 132px 1fr !important;
              padding: 0 8px !important;
            }
            .dashboard-logo-wrap img,
            .dashboard-logo-wrap svg {
              max-width: 100% !important;
              height: auto !important;
            }
            .dashboard-header {
              padding: 10px 12px !important;
              gap: 12px !important;
            }
            .dashboard-mod-row {
              gap: 4px !important;
              margin-top: 6px !important;
              padding-top: 8px !important;
              flex-wrap: nowrap !important;
            }
            .dashboard-mod-btn {
              min-width: 0 !important;
              max-width: none !important;
              height: 38px !important;
              padding: 0 6px !important;
              font-size: 11px !important;
              letter-spacing: 0.01em !important;
            }
            /* Ust satir (magaza + personel) hizli erisim dugmelerinin altina
               girmesin: genisligi sinirlanip tasan kisim kirpiliyor. */
            .dashboard-header > div:first-child > div:first-child {
              max-width: calc(100% - 300px) !important;
              overflow: hidden !important;
              flex-wrap: nowrap !important;
            }
            .dashboard-quick-row {
              right: 158px !important;
              top: 10px !important;
              gap: 4px !important;
            }
            .dashboard-quick-row button {
              width: auto !important;
              min-width: 0 !important;
              height: 30px !important;
              font-size: 9.5px !important;
              padding: 0 6px !important;
              white-space: nowrap !important;
            }
            .dashboard-quick-row button svg {
              font-size: 13px !important;
            }
            .dashboard-clock {
              width: 150px !important;
              min-width: 150px !important;
            }
            .dashboard-sidebar {
              padding: 10px 8px !important;
            }
            .dashboard-cat-btn {
              font-size: 11.5px !important;
              padding: 8px 8px !important;
            }
          }

          /* --- KOMPAKT DASHBOARD LAYOUT (telefon + dokunmatik tablet) ---
             Iki kosuldan biri yeterli:
               1) max-width: 600px            -> telefonlar (onceki davranis, aynen korundu)
               2) max-width: 1400px + any-pointer: coarse -> iPad/tablet (dokunmatik)
             "any-pointer: coarse" yalnizca dokunmatik girdisi OLAN cihazlarda dogrudur.
             Sadece fare/trackpad kullanan masaustu tarayicilar bu blogun HICBIR kuralini
             okumaz; masaustu gorunumu ekran genisligi ne olursa olsun degismez.
             "any-pointer" (pointer degil) secildi: klavye/trackpad takili iPad'lerde
             birincil girdi "fine" raporlanabiliyor, boyle iPadler de kapsama girer. */
          /* --- MOD ESIKLERI (3 gorunum) ---
             Telefon : <=600px            -> kompakt duzen
             Tablet  : dokunmatik <=1649  -> drawer menu
             Masaustu: fare ile >=1100    -> ust menu seridi (asagida daraltilir)
             Eskiden fare ile 1650 altinda da drawer aciliyordu; kullanici bunu
             "ikinci bir masaustu gorunumu" olarak gordugu icin esik 1100'e
             indirildi, serit de o genislige sigacak sekilde kucultuldu. */
          @media (max-width: 1099px), (max-width: 1649px) and (any-pointer: coarse) {
            .dashboard-root {
              grid-template-columns: 1fr !important;
              grid-template-rows: auto 1fr !important;
              /* Tek scroll alanı: dashboard-content */
              overflow: hidden !important;
              /* 100dvh iOS’ta adres çubuğu açılınca/kapanınca boyutu değiştirir → sayfa zıplar.
                 100svh sabit “küçük viewport”; kaydırırken düzen bozulmaz. */
              height: 100svh !important;
              max-height: 100svh !important;
              padding: 0 10px !important;
              box-sizing: border-box !important;
            }
            .dashboard-logo-wrap,
            .dashboard-header,
            .dashboard-sidebar {
              display: none !important;
            }
            .dashboard-content {
              grid-column: 1 / 2 !important;
              grid-row: 2 / 3 !important;
              display: flex !important;
              flex-direction: column !important;
              /* Grid + margin ile taşma olmasın; yatay boşluk padding ile */
              margin: 8px 0 !important;
              padding: 10px 8px !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
              min-height: 0 !important;
              box-sizing: border-box !important;
              border-radius: 16px !important;
              -webkit-overflow-scrolling: touch;
              overflow-x: hidden !important;
              overflow-y: auto !important;
            }
            .dashboard-mobile-topbar {
              display: block;
              grid-column: 1 / 2;
              grid-row: 1 / 2;
              margin: 8px 0 0 0;
              padding: 8px 8px 10px;
              width: 100%;
              max-width: 100%;
              min-width: 0;
              box-sizing: border-box;
              overflow-x: hidden;
              border-radius: 16px;
              border: 1px solid rgba(212, 175, 98, 0.14);
              background: linear-gradient(145deg, #141a22 0%, #0e1218 45%, #0a0d11 100%);
              color: #e8eaed;
              box-shadow: 0 18px 44px rgba(0, 0, 0, 0.55), inset 0 1px 0 rgba(255,255,255,0.04);
            }
            .dashboard-mobile-toprow {
              /* 1fr | auto | 1fr -> kenar sutunlar esit, logo gercekten ortalanir. */
              display: grid;
              grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
              align-items: center;
              gap: 8px;
              min-width: 0;
            }
            .dashboard-mobile-logo {
              /* Logo buyutuldu (58 -> 74px). Ust bar yuksekligi saat blogunun
                 yuksekligiyle belirlendiginden ve ic boşluk 6 -> 3px'e
                 indirildiginden bar yuksekligi pratikte degismiyor; sadece
                 logo isareti belirgin sekilde buyuyor. */
              justify-self: center;
              width: 74px;
              height: 74px;
              flex-shrink: 0;
              border-radius: 14px;
              border: 1px solid rgba(212, 175, 98, 0.18);
              background: linear-gradient(180deg, #faf8f4 0%, #f0ebe3 100%);
              box-shadow: 0 10px 26px rgba(0,0,0,0.45);
              display: inline-flex;
              align-items: center;
              justify-content: center;
              padding: 3px;
              cursor: pointer;
            }
            .dashboard-mobile-logo img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              border-radius: 10px;
            }
            .dashboard-mobile-clock {
              justify-self: end;
              min-width: 0;
              max-width: 100%;
              text-align: right;
              padding: 8px 8px;
              border-radius: 14px;
              border: 1px solid rgba(212, 175, 98, 0.20);
              background: radial-gradient(ellipse 120% 80% at 50% 0%, rgba(212, 175, 98, 0.10) 0%, transparent 55%), linear-gradient(165deg, #1a1f26 0%, #0d1014 100%);
            }
            .dashboard-mobile-time {
              font-size: 30px;
              font-weight: 300;
              letter-spacing: 0.08em;
              line-height: 1;
              font-variant-numeric: tabular-nums;
              color: #faf8f3;
            }
            .dashboard-mobile-date {
              margin-top: 4px;
              font-size: 12px;
              font-weight: 700;
              color: rgba(226, 232, 240, 0.92);
              line-height: 1.2;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .dashboard-mobile-day {
              margin-top: 2px;
              font-size: 11px;
              font-weight: 900;
              letter-spacing: 0.16em;
              color: rgba(212, 175, 98, 0.98);
              line-height: 1.15;
            }
            .dashboard-mobile-menu-btn {
              /* Kompakt: satirin solunda yer kaplamasin, genisligi icerigi kadar. */
              justify-self: start;
              height: 44px;
              padding: 0 12px;
              border-radius: 12px;
              border: 1px solid rgba(212, 175, 98, 0.32);
              background: rgba(255,255,255,0.05);
              color: rgba(245, 230, 200, 0.95);
              font-weight: 900;
              letter-spacing: 0.06em;
              text-transform: uppercase;
              font-size: 11px;
              display: inline-flex;
              align-items: center;
              justify-content: center;
              gap: 6px;
              cursor: pointer;
              max-width: 100%;
              min-width: 44px;
            }
            .dashboard-mobile-menu-label {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            /* Cok dar telefonlarda yazi gizlenir, ikon kalir. */
            @media (max-width: 360px) {
              .dashboard-mobile-menu-label { display: none; }
              .dashboard-mobile-menu-btn { padding: 0; width: 44px; }
            }
            .dashboard-mobile-quickbtns {
              display: contents;
            }
            .dashboard-mobile-quickbtn {
              height: 44px;
              border-radius: 12px;
              font-size: 11px;
              font-weight: 900;
              letter-spacing: 0.02em;
              border: 1px solid rgba(255,255,255,0.12);
              background: rgba(255,255,255,0.05);
              color: rgba(248, 250, 252, 0.92);
              cursor: pointer;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              padding: 0 6px;
              width: 100%;
              min-width: 0;
            }
            .dashboard-mobile-quickbtn.bank {
              border-color: rgba(59, 130, 246, 0.52);
              background: linear-gradient(170deg, #14253d 0%, #0f172a 55%, #0b1320 100%);
              color: #dbeafe;
            }
            .dashboard-mobile-quickbtn.camp {
              border-color: rgba(212, 175, 98, 0.52);
              background: linear-gradient(170deg, #181f29 0%, #0f141d 55%, #0b1016 100%);
              color: #f5e6c8;
            }
            .dashboard-mobile-quickbtn.invoice {
              border-color: rgba(16, 185, 129, 0.52);
              background: linear-gradient(170deg, #134e3a 0%, #0f2922 55%, #0b1f18 100%);
              color: #d1fae5;
            }
            .dashboard-content > div > .mk-page {
              flex: none !important;
              align-self: stretch !important;
            }
            .dashboard-content > div:has(.mk-page),
            .dashboard-content > div:has(.ok-page),
            .dashboard-content > div:has(.gka-page) {
              overflow: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
            }
            .dashboard-content > div > .ok-page {
              flex: none !important;
              align-self: stretch !important;
            }
            .dashboard-content > div > .gka-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div > .bank-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.bank-page) {
              overflow: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
            }
            .dashboard-content > div > .gr-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.gr-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .hr-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.hr-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .ar-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.ar-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .ro-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.ro-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .gf-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.gf-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .rf-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.rf-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .ky-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.ky-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .py-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.py-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .sy-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.sy-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .fb-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.fb-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .or-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.or-page) {
              overflow-x: hidden !important;
              overflow-y: visible !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content > div > .mg-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.mg-page) {
              overflow-x: hidden !important;
              overflow-y: auto !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content:has(.mg-page) {
              overflow-x: hidden !important;
            }
            .dashboard-content > div > .by-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.by-page) {
              overflow-x: hidden !important;
              overflow-y: auto !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content:has(.by-page) {
              overflow-x: hidden !important;
            }
            .dashboard-content > div > .ue-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.ue-page) {
              overflow-x: hidden !important;
              overflow-y: auto !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content:has(.ue-page) {
              overflow-x: hidden !important;
            }
            .dashboard-content > div > .ul-page {
              flex: none !important;
              align-self: stretch !important;
              width: 100% !important;
              max-width: 100% !important;
              min-width: 0 !important;
            }
            .dashboard-content > div:has(.ul-page) {
              overflow-x: hidden !important;
              overflow-y: auto !important;
              height: auto !important;
              min-height: 100% !important;
              flex: 1 1 auto !important;
              min-width: 0 !important;
              max-width: 100% !important;
            }
            .dashboard-content:has(.ul-page) {
              overflow-x: hidden !important;
            }
          }
        `}</style>

      </div>
    </PriceProvider>
  );
}

export default Dashboard;